import { moduleSuppliers } from "@/store/modules/moduleSuppliers";

/**
 * ItemPerTraveler
 *
 * defines how we collect quantity of hold/booking items
 * @prop supplierID: string
 */
export function ItemPerTraveler(): boolean {
  return (
    moduleSuppliers.RequiredGuestNamePerTraveler ||
    moduleSuppliers.RequireGuestEmailPerTraveler ||
    moduleSuppliers.RequiredGuestPhonePerTraveler ||
    moduleSuppliers.RequiredGuestWeightPerTraveler ||
    moduleSuppliers.RequiredGuestCountryPerTraveler
  );
}